import * as React from 'react';

import { cn } from './utils';

// ComponentProps (not InputHTMLAttributes) so a ref passes through, as React 19 allows.
export type InputProps = React.ComponentProps<'input'>;

function Input({ className, type, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-cmp-ink placeholder:text-cmp-ink-3 selection:bg-primary selection:text-primary-foreground border-cmp-line-2 flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base bg-cmp-raise text-cmp-ink transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
        className
      )}
      {...props}
    />
  );
}

export { Input };
